import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	total: 0,
	loan: null,
	loading: false,
	error: null,
};

// Load all loans
export const loadAllLoan = createAsyncThunk(
	"loan/loadAllLoan",
	async ({ page = 1, limit = 10, approvalStatus } = {}) => {
		try {
			const params = new URLSearchParams();
			if (page) params.append("page", page);
			if (limit) params.append("limit", limit);
			if (approvalStatus) params.append("approvalStatus", approvalStatus);

			const { data } = await axios.get(
				`loan?${params.toString()}`
			);
			return data;
		} catch (error) {
			// console.log(error.message);
			return { list: [], total: 0 };
		}
	}
);

// Add loan
export const addLoan = createAsyncThunk(
	"loan/addLoan",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
				},
				url: `loan/`,
				data: {
					...values,
				},
			});
			toast.success("Loan Application Created");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in creating loan, try again!");
			return {
				message: "error",
			};
		}
	}
);

// Count loans
export const countLoan = createAsyncThunk("loan/countLoan", async () => {
	try {
		const { data } = await axios.get(`loan/count`);
		return data;
	} catch (error) {
		// console.log(error.message);
		return { total: 0 };
	}
});

// Load loan by status
export const loadLoanByStatus = createAsyncThunk(
	"loan/loadLoanByStatus",
	async ({ page = 1, limit = 10, approvalStatus }) => {
		try {
			const params = new URLSearchParams();
			if (page) params.append("page", page);
			if (limit) params.append("limit", limit);
			if (approvalStatus) params.append("approvalStatus", approvalStatus);

			const { data } = await axios.get(
				`loan?${params.toString()}`
			);
			return data;
		} catch (error) {
			// console.log(error.message);
			return { list: [], total: 0 };
		}
	}
);

const loanSlice = createSlice({
	name: "loan",
	initialState,
	reducers: {
		clearLoan: (state) => {
			state.loan = null;
		},
	},
	extraReducers: (builder) => {
		// Load all loans
		builder.addCase(loadAllLoan.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(loadAllLoan.fulfilled, (state, action) => {
			state.loading = false;
			state.list = Array.isArray(action.payload?.list)
				? action.payload.list
				: Array.isArray(action.payload)
				? action.payload
				: [];
			state.total = action.payload?.total || action.payload?.list?.length || 0;
		});
		builder.addCase(loadAllLoan.rejected, (state, action) => {
			state.loading = false;
			state.error = action.error.message;
		});

		// Add loan
		builder.addCase(addLoan.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(addLoan.fulfilled, (state, action) => {
			state.loading = false;
			if (action.payload.message === "success") {
				// Optionally refresh the list
			}
		});
		builder.addCase(addLoan.rejected, (state, action) => {
			state.loading = false;
			state.error = action.error.message;
		});

		// Count loans
		builder.addCase(countLoan.fulfilled, (state, action) => {
			state.total = action.payload?.total || 0;
		});

		// Load loan by status
		builder.addCase(loadLoanByStatus.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(loadLoanByStatus.fulfilled, (state, action) => {
			state.loading = false;
			state.list = Array.isArray(action.payload?.list)
				? action.payload.list
				: Array.isArray(action.payload)
				? action.payload
				: [];
			state.total = action.payload?.total || action.payload?.list?.length || 0;
		});
		builder.addCase(loadLoanByStatus.rejected, (state, action) => {
			state.loading = false;
			state.error = action.error.message;
		});
	},
});

export default loanSlice.reducer;

